import { DatePipe, NgClass, TitleCasePipe } from "@angular/common";
import { Component, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";
import { UserRoleName } from "app/core/enums/user-role-name.enum";
import { ProviderDataReview } from "app/core/models/provider-data-review.model";
import { keyedProviderDataReviewTypeOptions } from "app/core/options/provider-data-review-type.opts";
import { keyedStatusOptions } from 'app/core/options/provider-status.opts';
import { AuthenticationService } from "app/core/services/authentication.service";
import { BlankValueDashComponent } from "app/shared/components/blank-value-dash/blank-value-dash.component";
import { CopyToClipboardComponent } from "app/shared/components/copy-to-clipboard/copy-to-clipboard.component";
import { OfficeComponent } from "app/shared/components/office/office.component";
import { BlankValueDashPipe } from "app/shared/pipes/blank-value-dash.pipe";
import { isEmpty } from "lodash-es";
import { ProviderDataReviewAssignmentsComponent } from "../provider-data-review-assignments/provider-data-review-assignments.component";
import { UserPresenceComponent } from "app/shared/components/user-presence/user-presence.component";
import { SpecialtyBadgesComponent } from '../../../shared/components/specialty-badges/specialty-badges.component';

@Component({
    selector: 'app-provider-data-review-list',
    templateUrl: './provider-data-review-list.component.html',
    styleUrls: ['./provider-data-review-list.component.scss'],
    imports: [
      NgClass,
      CopyToClipboardComponent,
      BlankValueDashPipe,
      TitleCasePipe,
      DatePipe,
      BlankValueDashComponent,
      OfficeComponent,
      ProviderDataReviewAssignmentsComponent,
      UserPresenceComponent,
      SpecialtyBadgesComponent
    ]
})
export class ProviderDataReviewListComponent implements OnInit {
  private authService = inject(AuthenticationService);

  @Input() dataReviews: ProviderDataReview[];
  @Input() selectedDataReviewIds: number[] = [];
  @Input() totalCount: number;
  @Input() showAssignedToCol = true;

  @Output() providerDataReviewSelected = new EventEmitter<ProviderDataReview>;
  @Output() providerDataReviewDeselected = new EventEmitter<ProviderDataReview>;
  @Output() assignmentUpdate = new EventEmitter<number>;
  @Output() assignmentClearSelection = new EventEmitter;

  keyedProviderDataReviewTypeOptions = keyedProviderDataReviewTypeOptions;
  keyedProviderStatusOptions = keyedStatusOptions;

  canManageProviderData = false;

  ngOnInit() {
    this.canManageProviderData = this.authService.hasPermissionTo(UserRoleName.manageProviderData);
  }

  isProviderDataReviewSelected(providerDataReview) {
    return this.selectedDataReviewIds.includes(providerDataReview.id);
  }

  onProviderDataReviewClick(event: Event, providerDataReview) {
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      this.providerDataReviewSelected.emit(providerDataReview);
    } else {
      this.providerDataReviewDeselected.emit(providerDataReview);
    }
  }

  onAssignmentUpdate(userId) {
    this.assignmentUpdate.emit(userId);
  }

  onAssignmentClearSelection() {
    this.assignmentClearSelection.emit();
  }

  get selectedCount() {
    return this.selectedDataReviewIds.length;
  }

  get showAssignmentComponent() {
    return this.canManageProviderData && !isEmpty(this.selectedDataReviewIds);
  }
}